import React, { useEffect, useState } from 'react';
import MainURL from '../../../MainURL';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdOutlineRemoveRedEye, MdOutlineAccessTime } from "react-icons/md";
import { FaFileAlt, FaDownload } from "react-icons/fa";
import { DateFormatExact } from '../../../components/DateFormmating';
import { useRecoilValue } from 'recoil';
import { recoilLoginState, recoilUserData } from '../../../RecoilStore';
import Footer from '../../../components/Footer';

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];

const parseAttachments = (raw: any): string[] => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const isImageAttachment = (filename: string) => {
  const lower = String(filename).toLowerCase();
  return IMAGE_EXTENSIONS.some((ext) => lower.endsWith(ext));
};

export default function BoardDetail (props:any) {

  const ID = props.ID;
  let navigate = useNavigate();
  const location = useLocation();
  const propsData = location.state;
  const isLogin = useRecoilValue(recoilLoginState);
  const userData = useRecoilValue(recoilUserData);
  
  const attachments = parseAttachments(location.state?.images);
  const imageAttachments = attachments.filter(isImageAttachment);
  const fileAttachments = attachments.filter((item) => !isImageAttachment(item));

  // 편집 상태
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [editDate, setEditDate] = useState<string>(propsData?.date || '');
  const [editTitle, setEditTitle] = useState<string>(propsData?.title || '');
  const [editContent, setEditContent] = useState<string>(propsData?.content || '');
  const [views, setViews] = useState<number>(Number(propsData?.views) || 0);

  // 게시글 조회시 조회수 증가
  useEffect(() => {
    if (!propsData?.id) return;
    axios
      .post(`${MainURL}/board/postsviews`, { postId: propsData.id })
      .then((res) => {
        if (res.data === true) {
          setViews((prev) => prev + 1);
        }
      })
      .catch((e) => console.error('조회수 증가 오류:', e));
  }, [propsData?.id]);

  const startEdit = () => {
    setEditTitle(propsData?.title || '');
    setEditDate(propsData?.date || '');
    setEditContent(propsData?.content || '');
    setIsEditing(true);
  };

  const cancelEdit = () => {
    setIsEditing(false);
  };

  const saveEdit = async () => {
    try {
      const payload = {
        id: propsData.id,
        title: editTitle,
        content: editContent
      };
      const res = await axios.post(`${MainURL}/board/updatepost`, payload);
      if (res.data === true) {
        alert('수정되었습니다.');
        // 로컬 표시 즉시 반영
        propsData.title = editTitle;
        propsData.content = editContent;
        setIsEditing(false);
      } else {
        alert('수정에 실패했습니다.');
      }
    } catch (e) {
      console.error('게시글 수정 오류:', e);
      alert('수정 중 오류가 발생했습니다.');
    }
  };

  // 게시글 삭제 함수 ----------------------------------------------
  const deletePost = () => {
    axios
      .post(`${MainURL}/board/deletepost`, {
        postId : propsData.id,
        userAccount : propsData.userAccount,
        images : attachments
      })
      .then((res) => {
        if (res.data === true) {
          alert('삭제되었습니다.');
          navigate('/board'); 
        } 
      });
  };


  return (
    <div className='board'>

      <div className="inner">

        <div className="subpage__main">

          <div className="subpage__main__title">
            <h3>공지사항</h3>
            <div style={{display:'flex'}}>
              <div className='postBtnbox'
                style={{marginRight:'10px'}}
                onClick={()=>{
                  navigate('/board'); 
                }}
              >
                <p>목록</p>
              </div>
              {
                (isLogin && userData.authInstitution === ID) &&
                <div className='postBtnbox'
                  style={{marginRight:'10px'}}
                  onClick={startEdit}
                >
                  <p>수정</p>
                </div>
              }
              {
                (isLogin && userData.authInstitution === ID) &&
                <div className='postBtnbox'
                  style={{marginRight:'10px'}}
                  onClick={()=>{
                    deletePost();
                  }}
                >
                  <p>삭제</p>
                </div>
              }
            </div>
          </div>
          
          <div className="subpage__main__content">
            
            <div className="top_box">
              <div className="left">
                <h1>{propsData.title}</h1>
                <p>글쓴이: {propsData.userNickName}님</p>
              </div>
              <div className="right">
                <div className='contentcover'>
                  <div className="box">
                    <MdOutlineAccessTime color='#325382'/>
                    <p>{DateFormatExact(propsData.date)}</p>
                  </div>
                  <div className="box">
                    <MdOutlineRemoveRedEye color='#325382'/>
                    <p>{views}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="view_content">
              {imageAttachments.length > 0 && (
                <div className='imagecover'>
                  {imageAttachments.map((item, index) => (
                    <img
                      key={`img-${index}`}
                      src={`${MainURL}/images/board/${item}`}
                      alt={item}
                    />
                  ))}
                </div>
              )}
              {fileAttachments.length > 0 && (
                <div className='filecover' style={{ margin: '20px 0', width: '100%' }}>
                  <p style={{ marginBottom: '10px', fontWeight: 600, color: '#325382' }}>첨부파일</p>
                  {fileAttachments.map((item, index) => (
                    <a
                      key={`file-${index}`}
                      href={`${MainURL}/images/board/${item}`}
                      download={item}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '12px 14px',
                        marginBottom: '8px',
                        border: '1px solid #E0E0E0',
                        borderRadius: '6px',
                        color: '#333',
                        textDecoration: 'none',
                        backgroundColor: '#F7F8FA',
                      }}
                    >
                      <FaFileAlt size={18} color="#325382" />
                      <span style={{ flex: 1, wordBreak: 'break-all' }}>{item}</span>
                      <FaDownload size={14} color="#325382" />
                    </a>
                  ))}
                </div>
              )}
              {isEditing ? (
                <div className='addPostBox' style={{ width:'100%' }}>
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'end'}}>
                    <p>날짜</p>
                  </div>
                  <input
                    className='inputdefault'
                    value={editDate}
                    maxLength={200}
                    onChange={(e)=>setEditDate(e.target.value)}
                    placeholder='제목'
                  />
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'end'}}>
                    <p>제목</p>
                    <h5 style={{fontSize:'12px'}}>* 최대 200자</h5>
                  </div>
                  <input
                    className='inputdefault'
                    value={editTitle}
                    maxLength={200}
                    onChange={(e)=>setEditTitle(e.target.value)}
                    placeholder='제목'
                  />
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'end', marginTop:'20px'}}>
                    <p>본문</p>
                    <h5 style={{fontSize:'12px'}}>* 최대 2000자</h5>
                  </div>
                  <textarea
                    className='textarea textareapost'
                    value={editContent}
                    maxLength={2000}
                    onChange={(e)=>setEditContent(e.target.value)}
                    placeholder='내용'
                  />
                  <div className='buttonbox' style={{ marginTop: 16 }}>
                    <div className='button' onClick={cancelEdit}><p>취소</p></div>
                    <div className='button' onClick={saveEdit}><p>저장</p></div>
                  </div>
                </div>
              ) : (
                <div className='textcover'>
                  <p>{propsData.content}</p>
                </div>
              )}

            </div>

          
          </div>
          
        </div>
      </div>

      <Footer />
      
    </div>
  )
}



